import styled from "styled-components"

export const Steps = styled.ol`
  position: relative;
  display: grid;
  gap: 1.75rem;
  margin: 0 0 4rem;
  padding: 0;
  list-style: none;
  @media (min-width: 992px) {
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 2.5rem;
    &::before {
      content: "";
      position: absolute;
      left: 0;
      right: 0;
      top: 20px;
      height: 2px;
      background: var(--line-strong);
    }
  }
  li {
    position: relative;
    display: grid;
    grid-template-columns: 40px minmax(0, 1fr);
    gap: 0 1rem;
    margin: 0;
    @media (min-width: 992px) {
      display: block;
    }
  }
  h3 {
    grid-column: 2;
    margin: 0.4rem 0 0.4rem;
    font-size: 1.25rem;
    @media (min-width: 992px) {
      margin-top: 1.25rem;
    }
  }
  p {
    grid-column: 2;
    margin: 0;
    color: var(--muted);
  }
`

export const Num = styled.span`
  position: relative;
  z-index: 1;
  grid-row: 1 / span 2;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: var(--navy);
  color: #fff;
  font-weight: 600;
  @media (min-width: 992px) {
    grid-row: auto;
  }
`

export const ValuesTitle = styled.h3`
  margin-bottom: 0.5rem;
`

export const Values = styled.ul`
  display: grid;
  gap: 0 3rem;
  margin: 0;
  padding: 0;
  list-style: none;
  @media (min-width: 768px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  li {
    margin: 0;
    padding: 1.1rem 0;
    border-top: 1px solid var(--line);
  }
  h4 {
    margin-bottom: 0.3rem;
  }
  p {
    margin: 0;
    color: var(--muted);
  }
`
